import { DataGrid } from "@mui/x-data-grid";

const Grid = ({
                  rows,
                  columns,
                  getRowId,
                  rowCount,
                  paginationModel,
                  onPaginationModelChange,
                  autoRowHeight = false,
                  onRowClick,
                  selectedRow ,
                  fixedHeight = false,
                  rowClassNameFn

}) => {
    return (
        <DataGrid
            rows={rows}
            columns={columns}
            getRowId={getRowId}

            paginationMode={rowCount > rows.length ? "server" : "client"}
            rowCount={rowCount ?? rows?.length ?? 0}

            onRowClick={(params) => {
                if (params.row.isHeader) return;
                if (onRowClick) onRowClick(params.row);
            }}

            getRowClassName={(params) => {
                if (params.row.isHeader) {
                    return "bg-gray-200 font-bold text-green-800";
                }

                if (params.row.className) return params.row.className;

                if (rowClassNameFn) return rowClassNameFn(params);

                if (
                    params.row.transaction_type === "IOU"
                ) {
                    return "bg-red-50";
                }

                return params.id === selectedRow
                    ? "bg-green-50"
                    : "";
            }}

            paginationModel={paginationModel}
            onPaginationModelChange={onPaginationModelChange}

            pageSizeOptions={[10, 25, 50, 100]}

            autoHeight={!fixedHeight}
            getRowHeight={(params) => {
                if (params.model?.isExpandedRow) return "auto";
                return autoRowHeight ? "auto" : null;
            }}
            disableRowSelectionOnClick

            sx={{
                height: fixedHeight ? "400px" : "auto",
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold"
                },
                "& .MuiDataGrid-cell": {
                    alignItems: "center"
                },
                "& .MuiDataGrid-row.bg-gray-200": {
                    pointerEvents: "none",
                    backgroundColor: "#e5e7eb"
                },
                "& .MuiDataGrid-row.bg-red-50": {
                    backgroundColor: "#fef2f2"
                },
                "& .MuiDataGrid-row.bg-gray-200 .MuiDataGrid-cell": {
                    gridColumn: "1 / -1"
                },
                "& .expanded-row .MuiDataGrid-cell": {
                    gridColumn: "1 / -1",
                    display: "block",
                    width: "100%",
                    padding: "0px"
                }
            }}
        />

    );
};

export default Grid;